// extracted by mini-css-extract-plugin
module.exports =  {"menuItem":"NavigationMenuItem__menu-item","selected":"NavigationMenuItem__selected"};